import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/AdminLayout.css"; // 👉 Optional: place reusable styles here

function AdminLayout({ children }) {
  const admin = JSON.parse(localStorage.getItem("admin"));
  const isSuperadmin = admin?.role === "superadmin";
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const isAdmin = localStorage.getItem("admin");
    const isUser = localStorage.getItem("user");

    if (!isAdmin) {
      alert("Admin login required.");
      window.location.href = "/admin-login";
    }

    if (isUser) {
      alert("You are logged in as a user. Please logout to access admin panel.");
      window.location.href = "/";
    }
  }, []);

  const canView = (key) =>
    isSuperadmin || admin?.permissions?.[key]?.view;

  return (
    <div className="admin-layout">
      {/* ✅ Sidebar */}
      <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
        <h2 className="logo">🛒 BigStyle Admin</h2>
        <nav className="sidebar-nav">
          {canView("dashboard") && <Link to="/admin">📊 Dashboard</Link>}

          {canView("products") && (
            <details>
              <summary>📦 Products</summary>
              <div className="submenu">
                <Link to="/admin/products/add">➕ Add Product</Link>
                <Link to="/admin/products">📦 Manage Products</Link>
              </div>
            </details>
          )}

          {canView("users") && <Link to="/admin/users">👥 Users</Link>}
          {canView("orders") && <Link to="/admin/orders">🧾 Orders</Link>}
          {canView("mandates") && <Link to="/admin/mandates">📝 eMandates</Link>}
          {canView("emi") && <Link to="/admin/emi-requests">📄 EMI Requests</Link>}
          {canView("banners") && <Link to="/admin/banners">🏞 Banners</Link>}

          {isSuperadmin && (
            <>
              <Link to="/admin/add-admin">👤 Add Admin</Link>
              <Link to="/admin/permissions">🛡 Permissions</Link>
            </>
          )}

          <button onClick={() => {
            localStorage.removeItem("admin");
            window.location.href = "/";
          }}>🚪 Logout</button>
        </nav>
      </aside>

      {/* ✅ Hamburger for Mobile */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* ✅ Main Content */}
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
}

export default AdminLayout;
